import { render, staticRenderFns } from "./DeveloperNew.vue?vue&type=template&id=260582ed"
import script from "./DeveloperNew.vue?vue&type=script&lang=js"
export * from "./DeveloperNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports